import {TFunction} from "i18next";

export const transReport = (report: Array<Array<string>>, t: TFunction): Array<Array<string>> => {
    if (report == null) return [];
    const r = report.map((l) => {
        return l.map((cell, index) => {
            // gl is column 33
            return index == 32 ?
                t("FS-ProductCategory-" + cell.replace("_", "-") + "-FullName", t("FS-ProductCategory-" + cell + "-FullName", t(cell)))
                : t(cell);
        })
    })
    return r;
}